module.exports = import("https://openfpcdn.io/fingerprintjs/v4");;